const languageSelector = [
    {
        selector: '[data-language-selector]',
        path: { filename: 'languageSelector' },
    },
];

export { languageSelector };
